export default "__VITE_ASSET__DrfQZbVQ__"